import { Link } from 'react-router-dom';

import { TemplateLimitCount } from '~/components/presets/template-limit';

// Picker copy for preset-authoring surfaces; the default copy in cara-input.tsx
// refers to "your message", which has no referent when defining a preset.
export const presetCustomFormPickerDescription = (
  <>
    Select up to <TemplateLimitCount /> forms from your{' '}
    <Link
      to="/app/library/forms"
      className="text-primary-600 dark:text-primary-400 hover:underline"
    >
      form library
    </Link>
    . Cara will fill them when generating deliverables from this preset.
  </>
);

export const presetWordTemplatePickerDescription = (
  <>
    Select Word document templates from your{' '}
    <Link
      to="/app/library/word-templates"
      className="text-primary-600 dark:text-primary-400 hover:underline"
    >
      Word docs library
    </Link>
    . Cara will fill them when generating deliverables from this preset.
  </>
);

export const presetHTMLTemplatePickerDescription = (
  <>
    Select document templates from your{' '}
    <Link
      to="/app/library/templates"
      className="text-primary-600 dark:text-primary-400 hover:underline"
    >
      template library
    </Link>
    . Cara will use them to generate styled documents from this preset.
  </>
);

export const presetExcelTemplatePickerDescription = (
  <>
    Select Excel spreadsheet templates from your{' '}
    <Link
      to="/app/library/excel-templates"
      className="text-primary-600 dark:text-primary-400 hover:underline"
    >
      Excel templates library
    </Link>
    . Cara will fill them when generating deliverables from this preset.
  </>
);
